export const MODULE_PREFIX = 'vehicleProtections';

export const VEHICLE_PROTECTION_TYPES = {
    insurance: 'insurance',
    upgrade: 'upgrade',
};
